import useClientDispatch from "src/shared/utilities/state/shared/hooks/useClientDispatch";

import {
  MERGE,
  RESET_CONTACT_FORM_TYPE,
  RESET_MESSAGE_SCREENING_FLAG,
  RESET_MODAL_AGENT,
  RESET_POST_SUBMIT_ANSWERS,
  RESET_QUESTIONNAIRE_STEP,
  SET_CONTACT_FORM_TYPE,
  SET_MESSAGE_SCREENING_FLAG,
  SET_MODAL_AGENT,
  SET_NEXT_QUESTIONNAIRE_STEP,
  SET_POST_SUBMIT_ANSWERS,
  SET_QUESTIONNAIRE_TOTAL_STEPS,
  SET_WHAT_YOU_SHOULD_KNOW_MODAL
} from "../../constants/reducer";

const useReducerActions = () => {
  const dispatch = useClientDispatch();

  const dispatchMerge = payload => dispatch({ payload, type: MERGE });

  const dispatchResetContactFormType = () =>
    dispatch({ type: RESET_CONTACT_FORM_TYPE });

  const dispatchSetContactFormType = type =>
    dispatch({
      payload: type,
      type: SET_CONTACT_FORM_TYPE
    });

  const dispatchResetModalAgent = () => dispatch({ type: RESET_MODAL_AGENT });

  const dispatchSetModalAgent = expert =>
    dispatch({ payload: expert, type: SET_MODAL_AGENT });

  const dispatchSetWhatYouShouldKnowModal = payload =>
    dispatch({ payload, type: SET_WHAT_YOU_SHOULD_KNOW_MODAL });

  const dispatchResetMessageScreeningFlag = () =>
    dispatch({ type: RESET_MESSAGE_SCREENING_FLAG });

  const dispatchSetMessageScreeningFlag = flag =>
    dispatch({ payload: flag, type: SET_MESSAGE_SCREENING_FLAG });

  const dispatchSetQuestionnaireTotalSteps = totalSteps =>
    dispatch({ payload: totalSteps, type: SET_QUESTIONNAIRE_TOTAL_STEPS });

  const dispatchResetQuestionnaireStep = () =>
    dispatch({ type: RESET_QUESTIONNAIRE_STEP });

  const dispatchSetNextQuestionnaireStep = () =>
    dispatch({ type: SET_NEXT_QUESTIONNAIRE_STEP });

  const dispatchResetPostSubmitAnswers = () =>
    dispatch({ type: RESET_POST_SUBMIT_ANSWERS });

  const dispatchSetPostSubmitAnswers = questions =>
    dispatch({ payload: questions, type: SET_POST_SUBMIT_ANSWERS });

  return {
    dispatchMerge,
    dispatchResetContactFormType,
    dispatchResetMessageScreeningFlag,
    dispatchResetModalAgent,
    dispatchResetPostSubmitAnswers,
    dispatchResetQuestionnaireStep,
    dispatchSetContactFormType,
    dispatchSetMessageScreeningFlag,
    dispatchSetModalAgent,
    dispatchSetNextQuestionnaireStep,
    dispatchSetPostSubmitAnswers,
    dispatchSetQuestionnaireTotalSteps,
    dispatchSetWhatYouShouldKnowModal
  };
};

export default useReducerActions;
